/* eslint-disable jsx-a11y/anchor-is-valid */
import {AppState, getStore} from "../RootReducer";
import {RouteComponentProps, withRouter} from "react-router";
import React, {Fragment} from "react";
import {MenuRoute, MenuRouteGroup} from "../services/MenuService";
import {getContainer} from "../ioc/IOCSetup";
import {NavLink} from "react-router-dom";

interface Props extends RouteComponentProps{

}

interface State {
    activeMainMenus : Set<string>;
    activeTopMenus? : Set<string>;
    routes: any;
}


class SideBar extends React.Component<Props,State> {
    constructor(props : Props) {
        super(props);
        this.state = { activeTopMenu : "Home",routes:[], activeMainMenus: new Set<string>(), activeTopMenus: new Set<string>()}
    }
    componentDidMount() {
        getContainer().getMenuService().getMenuRoutes({}).then((routes) => this.setState({routes}));
    }

    toggleMainMenu(menu : string) {
        let activeMenus : Set<string> = this.state.activeMainMenus;
        if(activeMenus.has(menu)) { activeMenus.delete(menu); }
        else { activeMenus.add(menu); }
        this.setState({ activeMainMenu: activeMenus})
    }

    toggleMenu(menu : string) {
        let activeMenus : Set<string> = this.state.activeTopMenus;
        if(activeMenus.has(menu)) { activeMenus.delete(menu); }
        else { activeMenus.add(menu); }
        this.setState({ activeTopMenus: activeMenus})
    }

    isMainMenuExpanded(title: String){
        if(!title){
            return false;
        }
        return this.state.activeMainMenu && this.state.activeMainMenu.has(title);
    }

    isExpanded(title : string, route?: string, children? : MenuRoute[]) : boolean {
        if(!title) {
            return false;
        }
        if(this.state.activeTopMenus.has(title)){
            return true;
        }
        return false;
        //return this.isCurrentPath(route, children)

    }
    isCurrentPath(menuRoute? : string, children? : MenuRoute[]) : boolean {

        let path = this.props.location.pathname;
        if(menuRoute === path) {
            return true;
        }

        if(!children) {
            return false;
        }

        return children.some( (c : MenuRoute) => {
            if(c.path === path) {
                return true;
            } else {
                return false;
            }
        });

        return false;
    }

    render() {
        let routes:[] = this.state.routes;
        let isSideBarContracted = getStore().getState().user.expandedMenu;
        console.log("gotten routes:", routes)
        console.log("gotten contracted:", isSideBarContracted)
        return (
            <div className={"left-side-menu"}>
                <div id="sidebar-menu" className="active">
                    <ul className="metismenu in" id={"side-menu"} style={{paddingTop : "10px"}}>

                        {routes.map( (route : MenuRouteGroup) => (
                            <Fragment key={route.id} >
                                { !route.hideTitle  && (
                                    <li className={"menu-title" + (this.isMainMenuExpanded(route.name)? " active": "")} onClick={()=> this.toggleMainMenu(route.name)}>
                                        <a className={""}>
                                            <span>{route.name}</span>
                                            <span className="menu-arrow"></span>
                                        </a>
                                    </li>
                                )}
                                {   (isSideBarContracted || route.hideTitle || this.isMainMenuExpanded(route.name)) &&
                                    route && route.routes && route.routes.map((r : MenuRoute) => {
                                        return (
                                            <li key={route.name + r.label} className={(route.hideTitle && this.isCurrentPath(r.path, [])) || (!route.hideTitle  && this.isExpanded(r.label, r.path, r.children)) ? "active" : ""}>
                                                <a  onClick={()=> this.toggleMenu(r.label)} className={(route.hideTitle && this.isCurrentPath(r.path, [])) || (!route.hideTitle  && this.isExpanded(r.label, r.path, r.children)) ? "active" : ""}>
                                                    <i className={"fe-"+r.icon}></i>
                                                    {r.path &&   <NavLink to={r.path}><span>{r.label}</span></NavLink>}
                                                    {!r.path &&  <span>{r.label}</span>}
                                                    {r.children && <span className="menu-arrow"></span>}
                                                    {!r.children && r.externalLink && <span className="fe-external-link" style={{right:"20px", position:"absolute"}}></span>}
                                                </a>
                                                {r.children && (
                                                <ul className={"nav-second-level collapse " + (this.isExpanded(r.label, r.path, r.children) ? "in" : "")} style={this.isExpanded(r.label, r.path, r.children) ? {} : {height :"0px"}}>
                                                    { r.children.map((c : MenuRoute)=>(
                                                        <li key={route.name + r.label + c.label} className={this.isCurrentPath(c.path, []) ? "active" : ""}>
                                                            {c.path && <NavLink to={c.path}>{c.label}</NavLink>}
                                                        </li>
                                                    ))}
                                                </ul>
                                                )}
                                            </li>
                                        )
                                    })
                                }
                            </Fragment>
                        ))}
                    </ul>
                </div>
            </div>

        )
    }
}
export default withRouter(SideBar);
